import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

type Value = {
  eventAnnouncementExpanded: boolean;
  supportMessengerOpen: boolean;
  setEventAnnouncementExpanded: (v: boolean) => void;
  setSupportMessengerOpen: (v: boolean) => void;
};

const FloatingCornerContext = createContext<Value | null>(null);

export function FloatingCornerProvider({ children }: { children: ReactNode }) {
  const [eventAnnouncementExpanded, setEventAnnouncementExpandedState] = useState(false);
  const [supportMessengerOpen, setSupportMessengerOpenState] = useState(false);

  const setEventAnnouncementExpanded = useCallback((v: boolean) => {
    setEventAnnouncementExpandedState(v);
  }, []);

  const setSupportMessengerOpen = useCallback((v: boolean) => {
    setSupportMessengerOpenState(v);
  }, []);

  const value = useMemo(
    () => ({
      eventAnnouncementExpanded,
      supportMessengerOpen,
      setEventAnnouncementExpanded,
      setSupportMessengerOpen,
    }),
    [
      eventAnnouncementExpanded,
      supportMessengerOpen,
      setEventAnnouncementExpanded,
      setSupportMessengerOpen,
    ],
  );

  return <FloatingCornerContext.Provider value={value}>{children}</FloatingCornerContext.Provider>;
}

/** Used by corner FABs / popovers so stacked actions can avoid overlapping open panels. */
export function useFloatingCorner(): Value {
  const ctx = useContext(FloatingCornerContext);
  if (!ctx) {
    return {
      eventAnnouncementExpanded: false,
      supportMessengerOpen: false,
      setEventAnnouncementExpanded: () => {},
      setSupportMessengerOpen: () => {},
    };
  }
  return ctx;
}
